import { useTranslation } from 'react-i18next';
import { AgentContact } from '@root/types';
import Avatar from './Avatar';
import s from './InquiryForm.module.less';

type Props = { agent: AgentContact; onButtonClick?: () => void };

const Agent = ({ agent, onButtonClick }: Props) => {
  const { t } = useTranslation('listing');

  return (
    <li className={s.agentItem}>
      <Avatar name={agent.name} photoUrl={agent.photoUrl} />
      <ul>
        <li className={s.name}>{agent.name}</li>
        {agent.role ? <li>{agent.role}</li> : null}
        {agent.company ? <li>{agent.company}</li> : null}
        <li>
          <button type="button" className={s.showContact} onClick={onButtonClick}>
            {t('sendEmail')}
          </button>
        </li>
      </ul>
    </li>
  );
};

export default Agent;
